module.exports = __webpack_public_path__ + "static/media/113.2327613c.png";